import { createReducer, on } from '@ngrx/store';
import { kioskEventsAdapter } from './state';
import { KioskEventsActions } from './actions';

export const kioskEventsReducer = createReducer(
  kioskEventsAdapter.getInitialState(),
  on(KioskEventsActions.addKioskEvents, (state, { kioskEvents }) => kioskEventsAdapter.setAll(kioskEvents, state))
);
